export const validAdminsRoles = ['admin', 'specialadmin', 'superadmin'];

export const validSuperAndSpecialAdminsRoles = ['specialadmin', 'superadmin'];
